// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"Cq-z","imageAndVideoCount":"Dq-z","imageAndVideoContainer":"Eq-z","viewAllReviews":"Fq-z"};